import * as React from "react";

const Gift = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="12"
    height="13"
    fill="none"
    viewBox="0 0 12 13"
  >
    <path
      stroke="#5B5B5B"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M1.111 6v4.889a1.22 1.22 0 0 0 1.223 1.222h7.333a1.22 1.22 0 0 0 1.222-1.222V6"
    ></path>
    <path
      stroke="#5B5B5B"
      strokeLinejoin="round"
      d="M6 2.639A2.14 2.14 0 0 0 3.863.5a1.528 1.528 0 1 0 0 3.056H6m0-.917v.917m0-.917A2.14 2.14 0 0 1 8.14.5a1.528 1.528 0 1 1 0 3.056H6"
    ></path>
    <path
      stroke="#5B5B5B"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M6 6v6.111M.5 3.556h11V6H.5z"
    ></path>
  </svg>
);

export default Gift;
